// extracted by mini-css-extract-plugin
export default {"enter":"FromRightSide_enter__p2Q87","enterActive":"FromRightSide_enterActive__0uM3A","exit":"FromRightSide_exit__BWykI","exitActive":"FromRightSide_exitActive__v6mcF"};